<mat-card class="h-100-p">
    <div fxLayout="row" fxLayoutAlign="space-between start">
        <div class="mat-title">Annotazioni</div>
        <button (click)="editingAnnotazioni = true" mat-icon-button><mat-icon>edit</mat-icon></button>
    </div>
    <mat-card-content>
        <div *ngIf="editingAnnotazioni === false; else editingAnnotazioniTemplate">
            <div *ngIf="annotazioni" [innerText]="annotazioni"></div>
        </div>
        <ng-template #editingAnnotazioniTemplate>
            <mat-form-field class="w-100-p" style="margin-top: -20px" [floatLabel]="'never'" [color]="'accent'">
                <textarea
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMaxRows="10"
                    [@animate]="{
                        value: '*',
                        params: { duration: '100ms' }
                    }"
                    class="w-100-p editing-annotazioni"
                    placeholder="Scrivi un annotazione"
                    id="annotazioni"
                    [formControl]="annotazioniFormControl">
                </textarea>
            </mat-form-field>
        </ng-template>
    </mat-card-content>

    <mat-card-actions
        [@animate]="{
            value: '*',
            params: { duration: '400ms' }
        }"
        *ngIf="editingAnnotazioni === true"
        align="right">
        <button (click)="onAnnullaAnnotazioni()" mat-stroked-button>Annulla</button>
        <button (click)="onSalvaAnnotazioni()" mat-raised-button color="accent">Salva</button>
    </mat-card-actions>
</mat-card>
